import React from 'react';
import { useAuth } from '@/contexts/EnterpriseAuthContext';
import { InactivityWarningModal } from './InactivityWarningModal';

export function InactivityMonitor() {
  const { isWarning, stayActive } = useAuth();

  return (
    <InactivityWarningModal
      isOpen={isWarning}
      onStayActive={stayActive}
    />
  );
}
